import { useEffect } from 'react';
import * as Api from '../Services/Api';

/**
 * Hook pour vérifier la validité du token au démarrage
 */
export const useInitializeAuth = () => {
  useEffect(() => {
    const checkToken = async () => {
      const existingToken = localStorage.getItem('token');
      if (existingToken) {
        try {
          await Api.fetchCantiques(); // simple call to check token
        } catch (error) {
          if (error.response?.status === 401) {
            localStorage.removeItem('token');
          }
        }
      }
    };

    checkToken();
  }, []);
};

export default useInitializeAuth;
